import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useCallback, useEffect } from 'react';
import { Icon24ChevronDown } from '@figma/fpl-icons/icon-24-chevron-down';
import { Icon24ChevronUp } from '@figma/fpl-icons/icon-24-chevron-up';
import clsx from 'clsx';
import { animate } from '../utils/animate.js';
import { addListener } from '../utils/event.js';
import { scrollArrow } from './menu-v2.css.js';

/** How many items will scroll by per second while hovering an arrow. */
const ITEMS_PER_SECOND = 15;
const MS_PER_ITEM = 1000 / ITEMS_PER_SECOND;
/** MenuV2.Arrow */
const Arrow = forwardRef(function Arrow({ className, dir, tick, ...props }, ref) {
    const cancel = useRef(null);
    const start = () => {
        if (cancel.current)
            return;
        const trigger = (amount) => {
            tick(dir === 'up' ? -amount : amount);
        };
        // Tick immediately when first hovered
        trigger(1);
        let total = 0;
        cancel.current = animate((delta) => {
            total += delta;
            if (total >= MS_PER_ITEM) {
                const amount = Math.floor(total / MS_PER_ITEM);
                total -= amount * MS_PER_ITEM;
                trigger(amount);
            }
        });
    };
    const stop = useCallback(() => {
        cancel.current?.();
        cancel.current = null;
    }, []);
    // Make sure we stop when the window loses focus so we don't get stuck
    // since we'll likely miss the pointerleave event
    //
    // stop is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => addListener(window, 'blur', stop), []);
    return (jsx("div", { "data-fpl-component": "", className: clsx(scrollArrow, className), ref: ref, "aria-hidden": true, onPointerMove: start, onPointerLeave: stop, "data-fpl-arrow": dir, ...props, children: dir === 'up' ? jsx(Icon24ChevronUp, {}) : jsx(Icon24ChevronDown, {}) }));
});
Arrow.displayName = 'MenuV2.Arrow';

export { Arrow };
//# sourceMappingURL=menu-v2.arrow.js.map
